import React from 'react';
import StripeCheckout from './payment_providers/stripe/stripe_checkout_form';
import StripeCheckoutWallet from './payment_providers/stripe/stripe_checkout_wallet';
import PayPalRest from './payment_providers/paypal/button';
import makePurchase from './payment_providers/api';
import {
  getPaymentProvider,
  addMessageToReturnUrls,
  getDomainString,
} from './helpers';
import {
  CheckoutViewProps,
  Currency,
  PaymentDetails,
  PaymentDomain,
} from './CheckoutTypes';

const CheckoutForms = ({
  affiliateId,
  baseUrl,
  beforeSubmitErrorCheck,
  callback,
  checkoutSubTotal,
  checkoutTotal,
  context,
  currency_symbol,
  currency,
  currentProductId,
  discounts,
  experiments,
  extraListings,
  extraListingsAvailable,
  inlinePayment = false,
  paymentProviders,
  paymentReturnUrls,
  paymentSuccessCallback,
  platform,
  siteId,
  staticFilesServer,
  stripeButtonText,
  stripeLabelText,
  upgradeContext,
  userId,
  localisations,
  walletButtons,
}: CheckoutViewProps) => {
  async function paymentSuccess(provider, token, subtype?: any, invoice?: any) {
    if (stripeLabelText == '') {
      stripeLabelText = localisations.enter_card_details;
    }
    const returnUrls =
      upgradeContext == 'contact_advertiser'
        ? addMessageToReturnUrls(paymentReturnUrls)
        : paymentReturnUrls;
    const paymentDetails: PaymentDetails = {
      currency: currency.toLocaleLowerCase() as Currency,
      paymentDomain: getDomainString(siteId) as PaymentDomain,
      paymentProvider: provider,
      platform: platform,
      userId: userId,
      products: [
        {
          id: currentProductId,
          quantity: 1,
        },
      ],
      token,
      amount: checkoutTotal,
    };
    if (context) {
      paymentDetails.context = context;
    }
    if (upgradeContext === 'my_account') {
      paymentDetails.upgradeContext = 'my_account';
    }
    if (affiliateId) {
      paymentDetails.affiliateId = affiliateId;
    }
    if (discounts?.promo_code && !discounts?.error) {
      paymentDetails.promo_code = discounts.promo_code;
    }
    if (extraListings && extraListings.count && extraListings.id) {
      paymentDetails.products.push({
        id: extraListings.id,
        quantity: extraListings.count,
      });
    }
    if (subtype) {
      paymentDetails.paymentProviderSubType = subtype;
    }
    if (upgradeContext == 'contact_advertiser') {
      returnUrls.success = '';
      let response;
      try {
        response = await makePurchase({
          paymentDetails,
          baseUrl,
          returnUrls,
          callback,
        });
        if (response) {
          if (response.actionRequired) {
            return response;
          }
          return paymentSuccessCallback();
        }
        return false;
      } catch {
        return response;
      }
    }
    return makePurchase({
      paymentDetails,
      baseUrl,
      returnUrls,
      callback,
    });
  }
  return (
    <menu className="checkout__options">
      {getPaymentProvider(paymentProviders, 'stripe') ? (
        <div className="checkout__stripe-form-container">
          <StripeCheckout
            autoFocus={!inlinePayment}
            beforeSubmitErrorMessage={beforeSubmitErrorCheck}
            buttonText={
              stripeButtonText ??
              `${localisations.pay} ${currency_symbol}${checkoutTotal}`
            }
            onSuccess={(id) => paymentSuccess('stripe', id)}
            staticFilesServer={staticFilesServer}
            titleText={stripeLabelText}
            formClass={
              inlinePayment ? 'stripe-form stripe-form--transparent' : undefined
            }
            localisations={localisations}
          />
        </div>
      ) : null}
      {getPaymentProvider(paymentProviders, 'stripe') &&
      getPaymentProvider(paymentProviders, 'paypal_rest') &&
      inlinePayment ? (
        <div className="checkout__options__provider-divider">
          {localisations.or}
        </div>
      ) : null}

      <div className="checkout__options-buttons">
        {getPaymentProvider(paymentProviders, 'paypal_rest') ? (
          <div className="paypal-button-wrapper">
            <PayPalRest
              amount={checkoutTotal}
              onSuccess={(id) => paymentSuccess('paypal', id)}
            />
          </div>
        ) : null}
        {walletButtons && getPaymentProvider(paymentProviders, 'stripe') ? (
          <StripeCheckoutWallet
            amount={checkoutTotal}
            onSuccess={(id, subtype?: any, invoice?: any) =>
              paymentSuccess('stripe', id, subtype, invoice)
            }
            localisations={localisations}
          />
        ) : null}
      </div>
    </menu>
  );
};

export default CheckoutForms;
